export default "__VITE_ASSET__LUw5wLLm__"